import React, { useContext, useEffect } from 'react';
import { loadImage } from '../../../../../lib/utils/utils';
import { StorefrontContext } from '../../../../../Context/StorefrontContext';
import AddImage from '../../../../../Assets/Add image.svg';
import { v4 as uuidv4 } from 'uuid';
import { CropImageContext } from '../../../../../Context/CropImageContext';

function ImageInput({ banner, image }) {
    const {
        carouselBannerDesktop,
        setCarouselBannerDesktop,
    } = useContext(StorefrontContext);

    const { setImageToCrop, croppedImage, setCroppedImage, isImageCropped, setIsImageCropped, setModalOpen, setAspectRatio } = useContext(CropImageContext);
    
    async function handleImageChange(e) {
        const file = e.target.files[0];
    
        if(file) {
            setImageToCrop(file);
            setAspectRatio(12 / 5);
            setModalOpen(true);
            e.target.value = null;
        }
    }
    
    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        setImageToCrop(file);
        setAspectRatio(12 / 5);
        setModalOpen(true);
    };
    
    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };
    
    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };
    
    const processFile = async (file) => {
        if(file) {
            const img = await loadImage(file);
            const bannerFound = carouselBannerDesktop.find(item => item.title === banner.title);
            const selectedImage = {
                id: image.id ? image.id : uuidv4(),
                url: img.src,
                file: file,
            }
    
            setCarouselBannerDesktop((prevCarouselBanner) =>
                prevCarouselBanner.map((item) =>
                    item.title === bannerFound.title
                        ? { ...item, image: selectedImage } 
                        : item
                )
            );
        }
        else {
            return;
        }
    }
    
    useEffect(() => {
        if(isImageCropped) {
            processFile(croppedImage);
            setIsImageCropped(false);
            setCroppedImage({});
            setModalOpen(false);
        }
        
        // eslint-disable-next-line
    }, [isImageCropped]);

    return (
        <div className='flex flex-col gap-2'>
            <p className='font-medium text-[14px] leading-6 text-[#121212]'>Image <span className='text-[12px] text-[#666666]'>&#40;1440px * 600px&#41;</span></p>

            <div 
                onDrop={handleDrop} 
                onDragOver={handleDragOver} 
                onDragLeave={handleDragLeave} 
                className="flex items-center gap-3"
            >
                {
                    image.url ? 
                    <div className="size-[100px] rounded-lg overflow-hidden flex items-center justify-center">
                        <img className='max-w-full max-h-full' src={image.url} alt="" />
                    </div> : 
                    <label htmlFor="carousel-image" className="cursor-pointer size-[100px] rounded-lg overflow-hidden bg-[#666666] flex items-center justify-center">
                        <img className='size-1/2' src={AddImage} alt="" />
                    </label>
                }

                <input 
                    id='carousel-image' 
                    name='carousel-image' 
                    className='hidden'
                    type="file" 
                    accept='image/*' 
                    onChange={handleImageChange} 
                />

                <label htmlFor='carousel-image' className='outline-none px-4 py-[6px] rounded-md bg-primaryColor hover:bg-primaryAccent font-semibold text-[12px] leading-6 text-buttonText cursor-pointer'>Change Image</label>
            </div>
        </div>
    );
}

export default ImageInput;
